import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { useChannelStateContext, useChatContext } from "stream-chat-react";
import { useSecondaryChatDisabled } from "../hooks/useChatDisabled";
import "../styles/SecondaryUserDisabledNotice.css";
import { SecondaryUserDisabledNoticeMessages } from "../constants";

const getDisplayName = (user) => {
  if (!user) return "";
  return (
    user.secondaryName ||
    user.secondary_name ||
    user.secondary?.name ||
    user.name ||
    user.id ||
    ""
  );
};

const SecondaryUserDisabledNotice = ({ displayName }) => {
  const { channel } = useChannelStateContext();
  const { client } = useChatContext();

  const otherMember = useMemo(() => {
    if (!channel || !client) return null;
    const members = Object.values(channel.state?.members || {});
    return members.find((m) => m?.user?.id && m.user.id !== client.userID)?.user || null;
  }, [channel, client]);

  const isSecondaryDisabled = useSecondaryChatDisabled(channel, client?.userID);
  const secondaryDisplayName = displayName || getDisplayName(otherMember);

  if (!isSecondaryDisabled || !secondaryDisplayName) return null;

  return (
    <div className="secondary-chat flex-center flex-col">
      <div className="secondary-chat-disable-title">
        {SecondaryUserDisabledNoticeMessages.title(secondaryDisplayName)}
      </div>
      <div className="secondary-chat-disable-desc">
        {SecondaryUserDisabledNoticeMessages.description}
      </div>
    </div>
  );
};

SecondaryUserDisabledNotice.propTypes = {
  displayName: PropTypes.string,
};

export default SecondaryUserDisabledNotice;